var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './store';
import CheckIcon from "src/icons/check";
import { Table } from 'rsuite';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const { Cell } = Table;
const cellKinds = { boolean: _ref => { let { value } = _ref; if (value) {
        return /*#__PURE__*/ _jsx(CheckIcon, { height: "1.2rem" });
    }
    else {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    } } };
const cellId = {};
const CellConstructor = _ref2 => {
    var _rowData$dataKey, _rowData$dataKey2, _rowData$dataKey3, _rowData$dataKey3$val;
    let { rowData, dataKey, rowClick, store } = _ref2, props = __rest(_ref2, ["rowData", "dataKey", "rowClick", "store"]);
    const kind = rowData === null || rowData === void 0 ? void 0 : (_rowData$dataKey = rowData[dataKey]) === null || _rowData$dataKey === void 0 ? void 0 : _rowData$dataKey.kind;
    const Viewer = store.cellID[dataKey] || store.cellKind[kind] || cellId[dataKey] || cellKinds[kind];
    return /*#__PURE__*/ _jsxs(Cell, Object.assign(Object.assign({}, props), { style: { cursor: "pointer" }, onClick: event => { const selection = window.getSelection(); if (rowClick && (selection === null || selection === void 0 ? void 0 : selection.type) !== 'Range') {
            rowClick(rowData, dataKey, event);
        } }, children: [Viewer && /*#__PURE__*/ _jsx(Viewer, { value: rowData === null || rowData === void 0 ? void 0 : (_rowData$dataKey2 = rowData[dataKey]) === null || _rowData$dataKey2 === void 0 ? void 0 : _rowData$dataKey2.value, rowData: rowData }), !Viewer && (rowData === null || rowData === void 0 ? void 0 : (_rowData$dataKey3 = rowData[dataKey]) === null || _rowData$dataKey3 === void 0 ? void 0 : (_rowData$dataKey3$val = _rowData$dataKey3.value) === null || _rowData$dataKey3$val === void 0 ? void 0 : _rowData$dataKey3$val.toString())] })) // <div  style={{width: width}} className={"tb-cell"}>
    ;
};
export default CellConstructor;
